/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Payload du bloc « INFORMATIONS SUR LE MARIAGE » : date et heure de la
 * célébration. Envoyé via `service.update`
 * (PUT `/numerisation-actes/mariage/{identifiant}`).
 *
 * ⚠️ Deux choses n'y sont PAS. Le LIEU de la célébration, qui est une ligne
 * `ec_acte_adresse` écrite par `PUT /acte-adresses/{id}` et enchaînée par la
 * modale. Et le CONTRAT, qui a son propre panneau, donc son propre builder.
 *
 * @param identifiant Identifiant de l'ACTE : construit l'URL du PUT.
 * @param data État du formulaire de la modale.
 */
const buildEvenementMariageUpdatePayload = (
  identifiant: number,
  data: Record<string, any>,
) => ({
  identifiant,
  acte: {
    identifiant,
    dateMariage: data?.dateMariage,
    heureMariage: data?.heureMariage,
    minuteMariage: data?.minuteMariage,
  },
});

export default buildEvenementMariageUpdatePayload;
